var maps = new Map();

function getCookie(name) {
    var matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value, options) {
    options = {
        path: '/',
    };

    if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
    }

    var updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

    for (var optionKey in options) {
        updatedCookie += "; " + optionKey;
        var optionValue = options[optionKey];
        if (optionValue !== true) {
            updatedCookie += "=" + optionValue;
        }
    }

    document.cookie = updatedCookie;
}

function deleteCookie(name) {
    setCookie(name, "", {
        'max-age': -1
    })
}

function responsiveMenu() {
    $('.rolled-menu .navbar-responsive__item').addClass('nav-item').appendTo('.navbar-responsive');

    var menu = $('.navbar-responsive');
    menu.find('.nav-item').addClass('navbar-responsive__item').children('a').addClass('nav-link').removeClass('dropdown-item');
    var maxWidth = menu.closest('.navbar').width();
    var items = $('.navbar-responsive .navbar-responsive__item:not(.rolled-menu)');
    var hideFrom = 0;
    var width = 0;

    if($(window).width() > 991) {
        width += menu.children('.rolled-menu').outerWidth(true);
        items.each(function (index) {
            if (width + $(this).outerWidth(true) > maxWidth) {
                return false;
            } else {
                hideFrom = index;
                width += $(this).outerWidth(true);
            }
        });

        if (hideFrom < items.length - 1) {
            items.eq(hideFrom).nextAll('.navbar-responsive__item:not(.rolled-menu)').appendTo('.rolled-menu .dropdown-menu');
            $('.rolled-menu .nav-item a').removeClass('nav-link').addClass('dropdown-item').parent().removeClass('nav-item');
            $('.rolled-menu').show();
        } else {
            $('.rolled-menu').hide();
        }
    } else {
        $('.rolled-menu').hide();
    }
}

function initSliders() {
    $('.owl-carousel:not(.owl-loaded)').each(function () {
        var slidesCount = $(this).children('.owl-carousel__item').length;
        var slider = $(this);
        var resp = null;
        var itemsCount = 1;

        if(slider.data('items')){
            var owlItems = slider.data('items').toString().split(",");
            itemsCount = owlItems[0];

            if(owlItems.length > 1){
                resp = {};
                if(owlItems[0]){
                    resp['1800'] = {items: owlItems[0]};
                    resp['1200'] = {items: owlItems[0]};
                    resp['992'] = {items: owlItems[0]};
                    resp['768'] = {items: owlItems[0]};
                    resp['576'] = {items: owlItems[0]};
                    resp['0'] = {items: owlItems[0]};
                }
                if(owlItems[1]){
                    resp['1200'] = {items: owlItems[1]};
                    resp['992'] = {items: owlItems[1]};
                    resp['768'] = {items: owlItems[1]};
                    resp['576'] = {items: owlItems[1]};
                    resp['0'] = {items: owlItems[1]};
                }
                if(owlItems[2]){
                    resp['992'] = {items: owlItems[2]};
                    resp['768'] = {items: owlItems[2]};
                    resp['576'] = {items: owlItems[2]};
                    resp['0'] = {items: owlItems[2]};
                }
                if(owlItems[3]){
                    resp['768'] = {items: owlItems[3]};
                    resp['576'] = {items: owlItems[3]};
                    resp['0'] = {items: owlItems[3]};
                }
                if(owlItems[4]){
                    resp['576'] = {items: owlItems[4]};
                    resp['0'] = {items: owlItems[4]};
                }
                if(owlItems[5]){
                    resp['0'] = {items: owlItems[5]};
                }
            }
        }

        slider.owlCarousel({
            autoplay: slider.data('autoplay') ? slider.data('autoplay') : false,
            autoplayTimeout: slider.data('autoplay') ? 5000 : 1000000,
            autoplayHoverPause: slider.data('autoplay') ? slider.data('autoplay') : true,
            margin: slider.data('margin') ? slider.data('margin') : 0,
            nav: slider.data('nav') ? slider.data('nav') : false,
            dots: slider.data('dots') ? slider.data('dots') : false,
            center: slider.data('center') ? slider.data('center') : false,
            items: itemsCount,
            responsive: resp,
            lazyLoad: true,
            loop: (slider.data('loop') && slidesCount > 1) ? slider.data('loop') : false,
            mouseDrag: slider.data('mousedrag') ? slider.data('mousedrag') : true,
            navText: [
                '<i class="icon-svg rotate-180"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330 330"><path d="M250.606 154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213.001-5.857 5.858-5.857 15.355.001 21.213l139.393 139.39L79.393 304.394c-5.857 5.858-5.857 15.355.001 21.213C82.322 328.536 86.161 330 90 330s7.678-1.464 10.607-4.394l149.999-150.004a14.996 14.996 0 000-21.213z"/></svg></i>',
                '<i class="icon-svg"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330 330"><path d="M250.606 154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213.001-5.857 5.858-5.857 15.355.001 21.213l139.393 139.39L79.393 304.394c-5.857 5.858-5.857 15.355.001 21.213C82.322 328.536 86.161 330 90 330s7.678-1.464 10.607-4.394l149.999-150.004a14.996 14.996 0 000-21.213z"/></svg></i>'
            ],
        });

        if(slider.next('.owl-carousel-thumbs').length > 0){
            var owlthumbs = slider.next('.owl-carousel-thumbs');
            var owlthumb = slider.next('.owl-carousel-thumbs').children('div');
            owlthumbs.children('div').eq(0).addClass('active');
            owlthumb.on('click', function(){
                $(slider).trigger('to.owl.carousel', $(this).parent().index());
                return false;
            });

            slider.on('changed.owl.carousel', function(el) {
                var count = el.item.count - 1;
                var current = el.item.index - ($(this).find('.owl-item.cloned').length > 0 ? $(this).find('.owl-item.cloned').length/2 : 0);
                if (current < 0) {
                    current = count;
                }
                if (current > count) {
                    current = 0;
                }
                owlthumb.removeClass('active');
                owlthumb.eq(current).addClass('active');

                $(owlthumbs).trigger('to.owl.carousel', current);
            });
        }
    });
}

function loadScript(url, callback){
    var script = document.createElement("script");

    if (script.readyState){  // IE
        script.onreadystatechange = function(){
            if (script.readyState == "loaded" ||
                script.readyState == "complete"){
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {
        script.onload = function(){
            callback();
        };
    }

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
}

function init() {
    $('.yandex-map').each(function () {
        var mapId = $(this).attr('id');
        loadMap(mapId);
    });
}

function loadMap(mapId) {
    var map = $('#' + mapId);
    if (typeof ymaps == "undefined" || maps.get(mapId) || !map.is(':visible')) {
        return
    }
    var myMap = new ymaps.Map(mapId, {
        center: [55.755814, 37.617635],
        zoom: 16
    }, {
        searchControlProvider: 'yandex#search'
    });

    if (mapId) {
        maps.set(mapId, myMap);
    }

    var url = map.data('ajax');
    if (url) {
        $.ajax({
            url: url,
            dataType: 'json'
        }).done(function(result) {
            for (var i = 0; i < result.length; i++) {
                var coords = result[i].Coords.split(',');
                var myCollection = new ymaps.GeoObjectCollection();
                var placemark = new ymaps.Placemark([coords[0], coords[1]], {
                    balloonContent:
                        '<h6><a href="' + result[i].Url + '">' + result[i].Name + '</a></h6>' +
                        '<img src="' + result[i].Img + '" width="300" class="mb-3">' +
                        '<p><b>Цена:</b> <span class="text-danger font-weight-bold">от ' + result[i].Price + ' р/сутки</span><br>' +
                        '<b>Адрес:</b> ' + result[i].Address + '</p>' +
                        '<a href="' + result[i].Url + '" class="btn btn-primary">Подробнее</a>'
                });

                myCollection.add(placemark);
                myMap.geoObjects.add(myCollection);

                myMap.setBounds(myCollection.getBounds(), { checkZoomRange: true }).then(
                    function() {
                        if (myMap.getZoom() > 9)
                            myMap.setZoom(9);
                    }
                );
            }
        });
    } else {
        var coords = map.data('coords').split(',');
        coords[0] = Number(coords[0]);
        coords[1] = Number(coords[1]);
        if (coords[0] && coords[1]) {
            var myCollection = new ymaps.GeoObjectCollection();
            var placemark = new ymaps.Placemark([coords[0], coords[1]]);

            myCollection.add(placemark);
            myMap.geoObjects.add(myCollection);

            zoomMap(mapId);
        }
    }
}

function zoomMap(mapId) {
    var map = maps.get(mapId);
    if (map) {
        map.setBounds(map.geoObjects.getBounds(), { checkZoomRange: true }).then(
            function() {
                if (map.getZoom() > 14)
                    map.setZoom(14);
            }
        );
    }
}

$(function(){
    initSliders();

    $('[data-toggle="tooltip"]').tooltip()

    $('a[href^="#"]:not([role="tab"])').on('click', function(event) {
        var id = $(this).attr("href");
        if ($(id).length) {
            event.preventDefault();
            if (id !== '#') {
                $('html, body').animate({
                    scrollTop: $(id).offset().top - $('.header-middle').height()
                }, 800);
            }
        }
    });

    $('.font-size__item').click(function () {
        $('.font-size__item').removeClass('active');
        $(this).addClass('active');
        var html = $('html');
        var fontSize = $(this).data('value');
        html.css('font-size', fontSize + 'px');
        setCookie('font-size', $(this).data('value'), {'max-age': 24 * 60 * 60});
    });
    $('.font-size__item.active').click();

    $('.font-color__item').click(function () {
        $('.font-color__item').removeClass('active');
        $(this).addClass('active');
        $('.eye-style').attr('href', '/assets/css/' + $(this).data('value') + '.css');
        setCookie('font-color', $(this).data('value'), {'max-age': 24 * 60 * 60});
    });
    $('.font-color__item.active').click();

    $('.images__item').click(function () {
        $('.images__item').removeClass('active');
        $(this).addClass('active');
        if ($(this).data('value')) {
            $('img').each(function () {
                var w = $(this).css('width');
                var h = $(this).css('height');
                $(this).css('width', '');
                $(this).css('height', '');
                $(this).attr('src', $(this).data('src'));
                $(this).data('src', '');
                $(this).removeClass('img-bordered');
            })
        } else {
            $('img').each(function () {
                var w = $(this).css('width');
                var h = $(this).css('height');
                $(this).css('width', w);
                $(this).css('height', h);
                $(this).data('src', $(this).attr('src'));
                $(this).removeAttr('src');
                $(this).addClass('img-bordered');
            })
        }
        setCookie('images', $(this).data('value'), {'max-age': 24 * 60 * 60});
    });
    $('.images__item.active').click();

    $('form[id^="nc_requests_form"], .ajax-form').submit(function (e) {
        e.preventDefault();

        var form = $(this);
        var ismodal = form.closest('.modal-body').length;

        var formData = new FormData();

        //Form data
        var form_data = form.serializeArray();
        $.each(form_data, function(key, input) {
            formData.append(input.name, input.value);
        });

        //File data
        form.find('input[type="file"]').each(function(index, el) {
            var file_data = $(this)[0].files;
            for (var i = 0; i < file_data.length; i++) {
                formData.append($(this).attr('name'), file_data[i]);
            }
        });

        formData.append('isNaked', '1');
        $.ajax({
            url: form.attr('action'),
            method: "POST",
            data: formData,
            dataType: "html",
            cache: false,
            contentType: false,
            processData: false,
        }).done(function(response) {
            if(response.indexOf('nc_error') > -1) {
                var warntext = form.parent().find('.warnText');
                if(warntext.length > 0){
                    warntext.html($(response).text());
                } else {
                    form.before('<p class="warnText text-danger">'+$(response).text()+'</p>');
                }
            } else {
                var parent = form.parent();
                if(ismodal){
                    parent.html(response);
                } else {
                    parent.html(response);
                }
                $('html, body').animate({
                    scrollTop: parent.offset().top
                }, 800);
                form[0].reset();
            }
        });
    });

    /*function applyFilter(form) {
        var resultElement = $(form.data('result-element'));
        resultElement.addClass('loading-ajax');
        $.ajax({
            url: form.attr('action'),
            method: form.attr('method'),
            data: form.serialize() + "&isNaked=1",
            dataType: "html",
            cache: false,
            contentType: false,
            processData: false,
        }).done(function(response) {
            resultElement.html(response);
            initSliders();
            $('.filter-form').submit(function (e) {
                e.preventDefault();
                applyFilter($(this));
            });

            var baseUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
            var newUrl = baseUrl + '?' + form.serialize();
            history.pushState(null, null, newUrl);

            resultElement.removeClass('loading-ajax');
        });
    }*/

    $('.filter-form').submit(function (e) {
        $(this).find('select').filter(function(){
            return !$.trim(this.value).length;
        }).prop('disabled',true);

        $(this).find('input').filter(function(){
            return !$.trim(this.value).length;
        }).prop('disabled',true);
    });

    $('.filter-form input[type="radio"]').change(function () {
        $(this).closest('form').submit();
    });

    $('.filter-form input[type="checkbox"]').change(function () {
        $(this).closest('form').submit();
    });

    $('.filter-form select').change(function () {
        $(this).closest('form').submit();
    });

    $('option[value="0"]').each(function () {
        $(this).html($(this).closest('select').attr('placeholder'));
        $(this).attr('value', '');
    });

    if(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)){
        $('.dropdown-toggle').click(function () {
            var parent = $(this).parent();
            if (parent.hasClass('hover')) {
                parent.removeClass('hover');
            } else {
                parent.addClass('hover');
            }
            return false;
        });
    }

    $('.scroll-top').click(function(){
        $("html, body").animate({
            scrollTop: 0
        }, 600);
        return false;
    });

    $(window).scroll(function() {
        if ($(this).scrollTop() > 100) {
            $('.scroll-top').fadeIn();
        } else {
            $('.scroll-top').fadeOut();
        }
        if ($(this).scrollTop() > $('.header-top').height() + 30) {
            $('.header').css('padding-bottom', $('.header-middle').height());
            $('.header-middle').addClass('fixed-top');
        } else {
            $('.header').css('padding-bottom', '0');
            $('.header-middle').removeClass('fixed-top');
        }
    });

    var check_if_load = false;
    var ymap = function() {
        setTimeout(function() {
            if (!check_if_load) {
                check_if_load = true;
                loadScript("https://api-maps.yandex.ru/2.1/?load=Map,Placemark,geoObject.addon.balloon&lang=ru_RU&loadByRequire=1", function() {
                    ymaps.load(init);
                });
            }
        }, 3000);
    };
    ymap();

    $('.city-search__input').keyup(function(){
        var searchResult = $('.city-search__result');

        $.get("/assets/ajax/city.php",
            {
                "name": $(this).val(),
                "url": location.pathname
            },
            function(data){
            searchResult.html(data);
            },
            'html'
        );
    });

    loadCaptcha = function() {
        $('.google-recaptcha').each(function () {
            var elementId = $(this).attr('id');
            var siteKey = $(this).data('key');
            grecaptcha.render(elementId, {
                'sitekey': siteKey
            });
        })
    };

    $(window).on('resize', function(){
        responsiveMenu();
    }).trigger('resize');

    $('.nav-tabs a').on('shown.bs.tab', function(event){
        var mapId = $(event.target).data('map');
        if (mapId) {
            loadMap(mapId);
        }
    });

    $('#mapModal').on('shown.bs.modal', function(){
        var mapId = 'mapAllObjects';
        if (mapId) {
            loadMap(mapId);
        }
    });
});